import { useState } from "@hookstate/core";
import { state } from "./state";

export const useJobPackage = () => {
  return useState(state.jobPackage);
};
